import React, { memo } from "react";
import { Stack, Alert, Typography } from "investira.react.components";
const ConsultaError = memo(props => {
  return <Stack flexGrow={1} justifyContent="center" alignItems="center" sx={{
    minHeight: "calc(100% - 220px)"
  }}>
      <Alert severity="error" variant="filled">
        {`Falha na geração do relatório. Entre em contato com o suporte.`}
        <Typography component={"span"} variant={"caption"} sx={{
        display: "block"
      }}>{`ID: ${props.outputId}`}</Typography>
      </Alert>
    </Stack>;
});
export default ConsultaError;
